import { render, staticRenderFns } from "./SystemDetails.vue?vue&type=template&id=4e1b13d5&scoped=true"
import script from "./SystemDetails.vue?vue&type=script&lang=js"
export * from "./SystemDetails.vue?vue&type=script&lang=js"
import style0 from "./SystemDetails.vue?vue&type=style&index=0&id=4e1b13d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1b13d5",
  null
  
)

export default component.exports